export default "__VITE_ASSET__Blacd_7N__"